/**
 * @generated SignedSource<<5dde0c581aca37263ed8e363759f0d89>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type datePickerField_updateWorkItemFieldsActionRenderer$data = {
  readonly fieldId: string;
  readonly name: string;
  readonly " $fragmentType": "datePickerField_updateWorkItemFieldsActionRenderer";
};
export type datePickerField_updateWorkItemFieldsActionRenderer$key = {
  readonly " $data"?: datePickerField_updateWorkItemFieldsActionRenderer$data;
  readonly " $fragmentSpreads": FragmentRefs<"datePickerField_updateWorkItemFieldsActionRenderer">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "datePickerField_updateWorkItemFieldsActionRenderer",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "fieldId"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    }
  ],
  "type": "JiraDatePickerField"
};

(node as any).hash = "79f4380b0255b1c99a5c97635b2d3805";

export default node;
